export default __webpack_public_path__ + "media/images/bottom-curve-9ee8a77545bb075b1aa72d1eb2e4e0c7.svg";